import DefaultLayout from "../layout/DefaultLayout";
import {
    Typography,
    Container,
    Box,
    Card,
    CardContent,
    CardMedia,
    useMediaQuery,
} from "@mui/material"
import { ThemeProvider, createTheme } from "@mui/material/styles"

const theme = createTheme({
    palette: {
        primary: {
            main: "#1976d2",
        },
        secondary: {
            main: "#f50057",
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h2: {
            fontWeight: 700,
            fontSize: "2.5rem",
        },
        h4: {
            fontWeight: 500,
        },
        body1: {
            fontSize: "1rem",
        },
    },
})

export default function HomePage() {
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

    const features = [
        {
            title: "Backend Development",
            description: "I specialize in robust and scalable backend development using frameworks like Laravel and Symfony, with secure APIs and efficient database structures. Whether it's building an authentication system, integrating third-party APIs, or creating RESTful services, I focus on clean architecture, performance, and security. I also deploy and manage applications in AWS environments.",
            image: "/imagen/img01.webp",
        },
        {
            title: "Web and mobil Application Development",
            description: "I design and develop modern web and mobile applications using React.js and React Native (Expo), delivering responsive and user-friendly interfaces. From UI/UX to backend integration, I build full-stack solutions tailored to each client's needs. I ensure that each app is optimized for speed, accessibility, and cross-platform compatibility.",
            image: "/imagen/img02.webp",
        },
        {
            title: "Databases Development",
            description: "I build efficient and secure database systems using MySQL, PostgreSQL, and Firebase, ensuring data integrity, scalability, and performance. I design relational models that support your application's growth, while also focusing on data encryption and secure access control when needed.",
            image: "/imagen/img06.webp",
        },
        {
            title: "Cloud Services",
            description: "I implement and manage cloud-based solutions using AWS, including EC2, S3, and Lambda. From setting up scalable infrastructure to continuous deployment pipelines (CI/CD), I ensure your applications run reliably and cost-effectively in the cloud. I also provide consulting on best practices for security and performance in cloud environments.",
            image: "/imagen/img04.webp",
        },
        {
            title: "Math and Circuits Teacher",
            description: "I'm a passionate educator with experience teaching Mathematics and Electrical Circuits at the university level. I combine a strong analytical mindset with the ability to explain complex concepts in simple and engaging ways. My background as a software developer allows me to integrate technology into the classroom, providing students with a modern, hands-on learning experience.",
            image: "/imagen/img05.webp",
        },
    ]

    return (
        <ThemeProvider theme={theme}>
            {/* Navigation Bar */}
            <DefaultLayout ubication={0} />

            {/* Hero Section */}
            <Box
                sx={{
                    position: "relative",
                    height: "70vh",
                    width: "100%",
                    overflow: "hidden",
                    backgroundImage: "url(/fondo.webp)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 8,
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.62)",
                    },
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        textAlign: "center",
                        color: "white",
                        px: 2,
                    }}
                >
                    <Typography variant="h2" component="h1" gutterBottom>
                        Innovative software solutions and knowledge
                    </Typography>
                    <Box sx={{ width: "70%", margin: "0 auto", textAlign: "center" }}>
                        <Typography variant="h5">
                            We transform your ideas into powerful digital products while sharing knowledge through education, bridging innovation with expertise in software development and teaching.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Feature Cards */}
            <Container maxWidth="lg" sx={{ mb: 8 }}>
                {features.map((feature, index) => (
                    <Card
                        key={index}
                        sx={{
                            display: "flex",
                            flexDirection: {
                                xs: "column", // En móvil, imagen arriba, texto abajo
                                sm: index % 2 === 0 ? "row" : "row-reverse" // En pantallas medianas/grandes, alternar lados
                            },
                            mb: 4,
                            overflow: "hidden",
                            borderRadius: 2,
                            boxShadow: 3,
                            height: { xs: "auto", sm: 300 }, // Altura automática en móvil
                        }}
                    >
                        <CardMedia
                            component="img"
                            sx={{
                                width: { xs: "100%", sm: "50%" },
                                height: "auto",
                                objectFit: "cover"
                            }}
                            image={feature.image}
                            alt={feature.title}
                        />
                        <CardContent
                            sx={{
                                width: { xs: "100%", sm: "50%" },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                p: { xs: 0, sm: 4 },
                            }}
                        >
                            <Box sx={{ width: { xs: "80%", sm: "90%" }, mx: "auto", textAlign: { xs: "center", sm: "left" } }}>
                                <Typography gutterBottom variant="h4" component="h2">
                                    {feature.title}
                                </Typography>
                            </Box>
                            <Box sx={{ width: { xs: "80%", sm: "90%" } , mx: "auto", textAlign: { xs: "left", sm: "left" } }}>
                                <Typography variant="body1" color="text.secondary">
                                    {feature.description}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>

                ))}
            </Container>

            {/* Footer */}
            <Box
                component="footer"
                sx={{
                    py: 1,
                    px: 2,
                    mt: "auto",
                    backgroundColor: (theme) => theme.palette.grey[100],
                    textAlign: "center",
                }}
            >
                <Container maxWidth="lg">
                    <Typography variant="body1" gutterBottom>
                        cesarbonilla.freelancer@gmail.com
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Copyright © 2025 All Rights Reserved By Cesar Bonilla
                    </Typography>
                </Container>
            </Box>
        </ThemeProvider>
    )
}